
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.094 11.11v-.5.5zM1.33 10.001l-.38-.324.38.324zm15.676 0l-.381.324.38-.324zM9.68 1.399l.38-.324-.38.324zm-1.023 0l-.38-.324.38.324zm.643.324l7.325 8.603.761-.648-7.325-8.603-.761.648zM1.71 10.326l7.327-8.603-.761-.648L.95 9.678l.761.648zm2.555.283H1.842v1h2.424v-1zm1.171 5.885v-4.713h-1v4.713h1zm7.313.172H5.61v1h7.14v-1zm.172-4.885v4.713h1v-4.713h-1zm3.572-1.172h-2.4v1h2.4v-1zm-2.572 1.172c0-.095.077-.172.172-.172v-1c-.647 0-1.172.525-1.172 1.172h1zm-1.172 5.885c.647 0 1.172-.525 1.172-1.172h-1a.172.172 0 01-.172.172v1zm-8.313-1.172c0 .647.525 1.172 1.172 1.172v-1a.172.172 0 01-.172-.172h-1zm-.171-4.885c.095 0 .171.077.171.172h1c0-.647-.524-1.172-1.171-1.172v1zM.95 9.678c-.648.76-.108 1.931.892 1.931v-1a.172.172 0 01-.131-.283L.95 9.678zm15.675.648a.172.172 0 01-.13.283v1c.998 0 1.54-1.17.891-1.931l-.761.648zm-6.564-9.25a1.172 1.172 0 00-1.784 0l.761.647a.172.172 0 01.262 0l.76-.648z","fill":"#000C1F"}})])
          )
        }
      }
    